<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef" :select-list.sync="selectList">
      <template slot="searchBar">
        <el-form-item label="设备型号">
          <el-input v-model.trim="tableData.search.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="SN">
          <el-input v-model.trim="tableData.search.sn" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button-group>
          <el-button v-if="checkApi('importTest')" size="small" type="primary" @click="add">导入授权</el-button>
          <el-button v-if="checkApi('reviseTest')" size="small" type="primary" @click="reviseBatch" :disabled="!selectList.length">批量修改</el-button>
          <el-button v-if="checkApi('deleteTest')" size="small" type="primary" @click="removeBatch" :disabled="!selectList.length">批量删除</el-button>
        </el-button-group>
      </template>
      <template v-if="hasApi(['reviseTest','deleteTest','downloadTestKey'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="160">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('downloadTestKey')" type="text" @click="downloadKey(row)">下载KEY</el-button>
            <el-button v-if="checkApi('reviseTest')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteTest')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <import-test v-if="importTest.visible" :dialog-data="importTest" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import ImportTest from "./dialog/ImportTest"
  export default {
    name: "testManage",
    components: {ImportTest},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "设备型号", property: "model"},
            {label: "SN", property: "sn", width: 200},
            {label: "激活芯片", property: "chip_id"},
            {label: "激活时间", property: "active_at"},
            {label: "授权到期时间", property: "expire_at"},
            {label: "导入时间", property: "create_at"},
            {label: "备注", property: "remark"},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getAuthTest",
          isMultiple: true,
          search: {
            model: "",
            sn: "",
          }
        },
        countList: [{name: "总记录", count: 0}],
        selectList: [],
        importTest: {visible: false, width: 500, title: "", row: null, isBatch: false},
      }
    },
    methods: {
      async downloadKey(row) {
        const nv = {auth_test_id: row.id}
        const blob = await this.$Http.downloadTestKey(nv, {responseType: "blob"});
        if (blob) {
          this.downloadFile(blob.name, blob);
        }
      },
      add() {
        this.importTest.visible = true;
        this.importTest.title = "导入授权";
        this.importTest.row = null;
        this.importTest.isBatch = false;
      },
      revise(row) {
        this.importTest.visible = true;
        this.importTest.title = "修改授权";
        this.importTest.row = row;
        this.importTest.isBatch = false;
      },
      reviseBatch() {
        this.importTest.visible = true;
        this.importTest.title = "批量修改授权";
        this.importTest.isBatch = true;
        this.importTest.row = {
          id: this.selectList.map(item => item.id),
          expire_at: "",
          remark: "",
        };
      },
      remove(row) {
        this.openConfirm("删除该授权码", async () => {
          let nv = {auth_test_id: row.id};
          let res = await this.$Http.deleteTest(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      removeBatch() {
        let length = this.selectList.length;
        this.openConfirm(`批量删除选中的 ${length} 个授权码`, async () => {
          let nv = {auth_test_id: this.selectList.map(item => item.id)};
          let res = await this.$Http.deleteTest(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
